// extracted by mini-css-extract-plugin
module.exports = {"headBg":"PortaleValorizzazioniTemplate_headBg__7YqdL","portaleValorizzazioniContent":"PortaleValorizzazioniTemplate_portaleValorizzazioniContent__yZmQg"};